export default __webpack_public_path__ + "static/media/dribbble-square.c78d85b1.svg";